import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { BranchProvider } from "@/context/BranchContext";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import Checkout from "@/pages/Checkout";
import Orders from "@/pages/Orders";
import Loyalty from "@/pages/Loyalty";
import Admin from "@/pages/Admin";
import Printing from "@/pages/Printing";
import Fasnet from "@/pages/Fasnet";
import IndoTravel from "@/pages/IndoTravel";
import Kost from "@/pages/Kost";
import Trading from "@/pages/Trading";
import Music from "@/pages/Music";
import RumahRakit from "@/pages/RumahRakit";
import Kasir from "@/pages/Kasir";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/loyalty" element={<Loyalty />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/printing" element={<Printing />} />
      <Route path="/fasnet" element={<Fasnet />} />
      <Route path="/indotravel" element={<IndoTravel />} />
      <Route path="/kost" element={<Kost />} />
      <Route path="/trading" element={<Trading />} />
      <Route path="/music" element={<Music />} />
      <Route path="/rumahrakit" element={<RumahRakit />} />
      <Route path="/kasir" element={<Kasir />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BranchProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
          </BranchProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
